import React, { useEffect } from "react";
import clsx from "clsx";
import {
  makeStyles, useTheme, Theme, AppBar, Toolbar,
  CssBaseline, Typography, IconButton,
  Grid, Paper, Drawer, Snackbar
} from "@material-ui/core";
import { Alert } from '@material-ui/lab'
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { getUserInfo, typeUserInfo, getMenuList, typeMenuList } from "../api/helpline/user"
import { UserPopUpcustomer, MenuListcustomer, Pagecustomer } from '../component/portalmenu/role/customer'
import { MenuListemployee, UserPopUpemployee, Pageemployee } from '../component/portalmenu/role/employee'
import { useGlobalState } from "../provider/Provider";
import { useHistory } from "react-router-dom";
import { cisUser } from "../User";

const drawerWidth = 220;
const mainPaperHeight = 86
const rolecustomer = process.env.REACT_APP_ROLE_CUSTOMER!
const ROOTPATH = process.env.REACT_APP_ROOT_PATH!


const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    "& input::-ms-clear, & input::-ms-reveal": {// Edge,IE clear button(x) hidden
      display: 'none'
    },
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {//toolbarIcon
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaper: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    padding: theme.spacing(3)
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    //display: 'flex',
    height: `${mainPaperHeight}vh`,
    // height: '100%',
    overflow: 'auto',
    flexDirection: 'column',
    flexGrow: 1,
  },
  fixedHeight: {
    height: 240,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
})
);

interface Props {
  logOut: () => void,
  handleError: (err: any) => void,
  notification: Notification,
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void,
  handleNotificationClose: (event?: React.SyntheticEvent<Element, Event> | undefined, reason?: string | undefined) => void,
}
interface Notification {
  open: boolean,
  level: "success" | "info" | "warning" | "error" | undefined,
  message: string,
}

const PortalMenu: React.FC<Props> = (props) => {
  const globalState = useGlobalState('user')
  const { userId, token, role } = globalState
  const history = useHistory()
  const { logOut, handleError, notification, handleNotificationOpen, handleNotificationClose } = props

  //メニューリスト取得サービス
  const [menuListData, setMenuListData] = React.useState<typeMenuList[] | undefined>()
  const [menulistopen, setMenuListOpen] = React.useState<{
    [x: string]: boolean;
  }[] | undefined>()

  //ユーザー情報取得サービス
  const [userInfo, setUserInfo] = React.useState<typeUserInfo | undefined>()
  useEffect(() => {
    if (userId && token && role) {
      getUserInfo(userId, userId, token, role).then(res => setUserInfo(res)).catch(err => handleError(err))
      getMenuList(userId, token, role).then(res => {
        setMenuListData(res)
        type menuObj = typeof menuListData
        const getMenuListObj = (menulistdata: menuObj): { [x: string]: boolean }[] => {
          let menuList = []
          let subList = []
          let item = []
          for (const submenu of menulistdata!) {
            for (const submen of submenu!.menu) {
              menuList.push(submen.displayName)
              for (const subme of submen.menu) {
                item.push(subme.displayName)
              }
              subList.push(item)
              item = []
            }
          }
          let obj = menuList.map(([k, v]) => ({ [k]: false }))
          return obj
        }
        setMenuListOpen(getMenuListObj(res))
      }).catch(err => handleError(err))
    }
  }, [globalState])

  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState<boolean>(false);
  const [value, setValue] = React.useState("")
  const [pagehome, setPagehome] = React.useState(true)
  const [update, setUpdata] = React.useState<boolean>(false)
  const handleHomeHistory = () => {
    setPagehome(true)
  }
  const handleListHistory = () => {
    setPagehome(false)
  }
  const handleClickQAno = (num: string) => {
    setValue('')
    if (num) {
      history.push(`${ROOTPATH}/qas/${btoa(num)}`)
    }
  }

  const handleClickKeiyakuno = (num: string) => {
    setValue('')
    if (num) {
      history.push(`${ROOTPATH}/contract/${btoa(num)}`)
    }
  }

  const handleClickHome = () => {
    setUpdata(update ? false : true)
    setValue("home")
  }

  const handleListItemClick = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    text: string,
    qaListId?: string
  ) => {
    setUpdata(update ? false : true)
    setValue(text);
  };
  const handleChangeSubMenu = (menuId: string) => {
    setOpen(true)
    if (menulistopen) {
      setMenuListOpen({
        ...menulistopen,
        [menuId]: !menulistopen[menuId] as boolean
      });
    }
  }

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    if (menulistopen) {
      let initobj = menulistopen
      for (const [key] of Object.entries(initobj)) {
        let name = key
        initobj[name] = false
      }
      setMenuListOpen(initobj)
    }
    setOpen(false);
  };


  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.menuButtonHidden]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
            <IconButton onClick={handleClickHome} color="inherit">
              CIS ヘルプラインシステム
              </IconButton>
          </Typography>
          <UserPopUp handleListItemClick={handleListItemClick} userInfo={userInfo} logOut={logOut} menuListData={menuListData} />
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerPaper]: open,
          [classes.drawerPaperClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerPaper]: open,
            [classes.drawerPaperClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        {/* Menu */}
        {role === rolecustomer && <MenuListcustomer menuListData={menuListData} menulistopen={menulistopen} handleChangeSubMenu={handleChangeSubMenu} handleListItemClick={handleListItemClick} />}
        {cisUser(role) && <MenuListemployee menuListData={menuListData} menulistopen={menulistopen} handleChangeSubMenu={handleChangeSubMenu} handleListItemClick={handleListItemClick} />}
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Grid container spacing={3}>
          {/* Page */}
          <Paper className={classes.paper}>
            {role === rolecustomer && <Pagecustomer
              value={value}
              update={update}
              handleListItemClick={handleListItemClick}
              handleClickQAno={handleClickQAno}
              handleHomeHistory={handleHomeHistory}
              pagehome={pagehome}
              handleError={handleError}
              handleListHistory={handleListHistory}
              handleClickHome={handleClickHome}
              handleNotificationOpen={handleNotificationOpen}
            />}
            {cisUser(role) && <Pageemployee
              value={value}
              update={update}
              handleListItemClick={handleListItemClick}
              handleClickQAno={handleClickQAno}
              handleHomeHistory={handleHomeHistory}
              pagehome={pagehome}
              handleError={handleError}
              handleListHistory={handleListHistory}
              handleClickHome={handleClickHome}
              handleNotificationOpen={handleNotificationOpen}
              handleClickKeiyakuno={handleClickKeiyakuno}
            />}
          </Paper>
        </Grid>
      </main>
      {notification.level === 'error' ? (
        <Snackbar open={notification.open} onClose={handleNotificationClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
          <Alert onClose={handleNotificationClose} severity={notification.level} variant="filled">
            エラーが発生しました。管理者にお問い合わせください。{<br />}
            {notification.message}
          </Alert>
        </Snackbar>) : (
        <Snackbar open={notification.open} autoHideDuration={5000} onClose={handleNotificationClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
          <Alert onClose={handleNotificationClose} severity={notification.level} variant="filled">
            {notification.message}{notification.level === 'success' && 'が完了しました'}
          </Alert>
        </Snackbar>)}
    </div>
  );
};

interface PopUpProps {
  handleListItemClick: (event: React.MouseEvent<HTMLElement, MouseEvent>, text: string) => void,
  logOut: () => void,
  userInfo: typeUserInfo | undefined,
  menuListData: typeMenuList[] | undefined,
}

const UserPopUp: React.FC<PopUpProps> = (props) => {
  const globalState = useGlobalState('user')
  const { role } = globalState
  const { handleListItemClick, logOut, menuListData, userInfo } = props
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openaccount = Boolean(anchorEl);
  //const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const memDisplayName = (listdata: typeMenuList[], menuId: string): string | undefined => {
    for (const a of listdata) {
      for (const b of a.menu) {
        for (const c of b.menu) {
          if (c.menuId.indexOf(menuId) !== -1)//ユーザー設定のmenuId
            return c.displayName
        }
      }
    }
  }

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const clickName = (event: React.MouseEvent<HTMLElement>) => {
    const name = event.currentTarget.textContent
    if (name !== null) {
      handleListItemClick(event, name)
    }
    handleClose()
  }

  return (
    <React.Fragment>
      <IconButton
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
      >
        <AccountCircle />
        <Typography variant="body1">
          {userInfo && (userInfo.userName)} 様
          </Typography>
      </IconButton>
      {/* PopUp */}
      {role === rolecustomer && <UserPopUpcustomer anchorEl={anchorEl} openaccount={openaccount} handleClose={handleClose} handleListItemClick={handleListItemClick} memDisplayName={memDisplayName} menuListData={menuListData} clickName={clickName} logOut={logOut} />}
      {cisUser(role) && <UserPopUpemployee anchorEl={anchorEl} openaccount={openaccount} handleClose={handleClose} logOut={logOut} />
      }
    </React.Fragment>
  )
}

export default PortalMenu;
